import { Button, Dialog, Text } from '@uhg-harmony/uitk-react';
import { toast } from 'react-toastify';

interface DeleteCustomThemeDialogProps {
  themeKey: number;
  themeName?: string;
  deleteCustomThemeDialogOpen: boolean;
  setDeleteCustomThemeDialogOpen: (open: boolean) => void;
  handleDeleteCustomTheme: (key: number) => void;
}

const DeleteCustomThemeDialog = (props: DeleteCustomThemeDialogProps) => {
  const {
    themeKey,
    themeName,
    deleteCustomThemeDialogOpen,
    handleDeleteCustomTheme,
    setDeleteCustomThemeDialogOpen,
  } = props;

  const confirmDeleteTheme = (key, name) => {
    handleDeleteCustomTheme(key);
    setDeleteCustomThemeDialogOpen(false);
    toast(`${name} deleted successfully`, {
      type: 'success',
      theme: 'colored',
    });
  };

  return (
    <>
      {deleteCustomThemeDialogOpen && (
        <Dialog
          data-test-id="delete-template-dialog"
          open={deleteCustomThemeDialogOpen}
          title={`Delete ${themeName}?`}
          titleAs="h3"
          onClose={() => setDeleteCustomThemeDialogOpen(false)}
        >
          <Dialog.Body>
            <Text>
              Are you sure you want to delete the custom theme:{' '}
              {<b>{themeName}</b>}? This action cannot be undone.
            </Text>
          </Dialog.Body>
          <Dialog.Actions>
            <Button
              data-test-id="delete-template-button"
              onPress={() => confirmDeleteTheme(themeKey, themeName)}
            >
              Delete
            </Button>
            <Button
              data-test-id="cancel-delete-template-button"
              variant="secondary"
              onPress={() => setDeleteCustomThemeDialogOpen(false)}
            >
              Cancel
            </Button>
          </Dialog.Actions>
        </Dialog>
      )}
    </>
  );
};

export default DeleteCustomThemeDialog;
